import * as yup from "yup";


const addAndChangeSchema = (translate: Function) => yup.object().shape({
	tea001Titulo: yup.string().required(translate("Titulo é requerido")),
	tea001Tipo: yup.string().required(translate("Ativo é requerido")).oneOf(["1", "2"]),
	tea001Dtinicio: yup.date()
		.required(translate("Data inicial do período é requerida"))
		.nullable()
		.typeError(translate("Data inicial com data inválida")),
	tea001Dtfim: yup.date()
		.required(translate("Data final do período é requerida"))
		.typeError(translate("Data final com data inválida"))
		.nullable()
		.when("tea001Dtinicio",(initialDate,schema) => initialDate ? schema.min(initialDate,translate("Data final não pode ser menor que a inicial")):schema)
});

export default addAndChangeSchema;
